import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { LibraryRouter } from '@app/models/library.router';
import { AuthService, CommentService, ContextService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { Comment, Content } from 'lingo2-models';
import { takeUntil } from 'rxjs/operators';
import striptags from 'striptags';

@Component({
  selector: 'app-comment-form',
  templateUrl: './comment-form.component.html',
  styleUrls: ['./comment-form.component.scss'],
})
export class CommentFormComponent extends ChangableComponent {
  private authService = inject(AuthService);
  private contextService = inject(ContextService);
  private commentService = inject(CommentService);

  @Input()
  public set content(content: Content) {
    this._content = content;
  }

  @Output() commented = new EventEmitter<boolean>();
  public me$ = this.contextService.me$;
  public new_comment = '';
  public submitting: boolean;
  public animating = false;
  public contentRoute = LibraryRouter.contentRouteUniversal;
  private _content: Content;

  public submit() {
    const text = striptags(this.new_comment).trim();
    if (text.length < 1 || this.submitting) {
      return;
    }

    this.animating = true;
    this.submitting = true;
    const values: Partial<Comment> = {
      text,
      // TODO new thread default options OR thread type
    };
    this.commentService
      .createThreadComment(this._content.id, values)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (comment) => {
          this.setTimeout(() => {
            this.animating = false;
          }, 1000);
          this.new_comment = '';
          this.submitting = false;
          this.commented.emit(true);
          this.detectChanges();
        },
        error: (error: any) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
          this.submitting = false;
        },
      });
  }

  public authorize() {
    this.authService.showAuthModal();
  }
}
